// extracted by mini-css-extract-plugin
export default {"paragraph":"styles_paragraph__Igy7f"};